<template>
  <div>
    <div
      class="kingster-page-title-wrap  kingster-style-custom kingster-left-align"
      :style="
        'background-image: url(' +
          require('@/assets/images/template4/shutterstock_59887279.jpg') +
          ')'
      "
    >
      <div class="kingster-header-transparent-substitute"></div>
      <div class="kingster-page-title-overlay"></div>
      <div class="kingster-page-title-bottom-gradient"></div>
      <div class="kingster-page-title-container kingster-container">
        <div
          class="kingster-page-title-content kingster-item-pdlr"
          style="padding-top: 400px ;padding-bottom: 60px ;"
        >
          <div
            class="kingster-page-caption"
            style="font-size: 21px ;font-weight: 400 ;letter-spacing: 0px ;"
          >
            Jurusan Sekolah
          </div>
          <h1
            class="kingster-page-title"
            style="font-size: 48px ;font-weight: 700 ;text-transform: none ;letter-spacing: 0px ;color: #ffffff ;"
          >
            {{ meta.name }}
          </h1>
        </div>
      </div>
    </div>
    <div class="kingster-breadcrumbs">
      <div class="kingster-breadcrumbs-container kingster-container">
        <div class="kingster-breadcrumbs-item kingster-item-pdlr">
          <span property="itemListElement" typeof="ListItem"
            ><router-link
              :to="`/${meta.preview}`"
              property="item"
              typeof="WebPage"
              title="Go to Kingster."
              class="home"
              ><span property="name">Home</span></router-link
            >
            <meta property="position" content="1" /> </span
          >&gt;<span property="itemListElement" typeof="ListItem"
            ><span property="name"> Jurusan Sekolah </span>
            <meta property="position" content="2" />
          </span>
        </div>
      </div>
    </div>
    <div class="kingster-page-wrapper" id="kingster-page-wrapper">
      <div class="gdlr-core-page-builder-body">
        <div
          class="gdlr-core-pbf-sidebar-wrapper "
          style="margin: 0px 0px 30px 0px;"
        >
          <div
            class="gdlr-core-pbf-sidebar-container gdlr-core-line-height-0 clearfix gdlr-core-js gdlr-core-container"
          >
            <div
              class="gdlr-core-pbf-sidebar-content  gdlr-core-column-40 gdlr-core-pbf-sidebar-padding gdlr-core-line-height gdlr-core-column-extend-left"
              style="padding: 35px 0px 20px 0px;"
            >
              <div class="gdlr-core-pbf-sidebar-content-inner">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 40px ;"
                  >
                    <div class="gdlr-core-title-item-title-wrap clearfix">
                      <h3
                        class="gdlr-core-title-item-title gdlr-core-skin-title "
                        style="font-size: 22px ;font-weight: 600 ;letter-spacing: 0px ;text-transform: none ;color: #223d71 ;margin-right: 30px ;"
                      >
                        Jurusan
                      </h3>
                      <div
                        class="gdlr-core-title-item-divider gdlr-core-right gdlr-core-skin-divider"
                        style="font-size: 22px ;border-bottom-width: 3px ;"
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  v-for="(jurusan, index) in majors"
                  :key="`jurusan_${index}`"
                  data-aos="zoom-in"
                  :data-aos-duration="index + `000`"
                  :data-aos-delay="index + `00`"
                >
                  <div class="gdlr-core-pbf-column gdlr-core-column-20">
                    <div
                      class="gdlr-core-pbf-column-content-margin gdlr-core-js "
                      style="margin: 0px -7px 0px 0px;"
                    >
                      <div
                        class="gdlr-core-pbf-column-content clearfix gdlr-core-js "
                      >
                        <div class="gdlr-core-pbf-element">
                          <div
                            class="gdlr-core-feature-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                          >
                            <div
                              class="gdlr-core-feature-box gdlr-core-js gdlr-core-feature-box-type-outer"
                              style="background-color: #3db166 ;border-width: 0px 0px 0px 0px;border-radius: 3px;-moz-border-radius: 3px;-webkit-border-radius: 3px;"
                            >
                              <div
                                class="gdlr-core-feature-box-background"
                                style="background-image: url(upload/shutterstock_209187682.jpg) ;opacity: 0.14 ;"
                              ></div>
                              <div
                                class="gdlr-core-feature-box-content gdlr-core-sync-height-content"
                              >
                                <h3
                                  class="gdlr-core-feature-box-item-title"
                                  style="font-size: 16px ;font-weight: 600 ;"
                                >
                                  {{ jurusan.title }}
                                </h3>
                              </div>
                              <router-link
                                class="gdlr-core-feature-box-link"
                                :to="`/jurusan-detail/${jurusan.url}`"
                                target="_self"
                              ></router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="gdlr-core-pbf-element"
                  data-aos="zoom-in"
                  :data-aos-duration="`3000`"
                  :data-aos-delay="`300`"
                >
                  <div
                    class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                    style="padding-bottom: 15px ;"
                  >
                    <div
                      class="gdlr-core-text-box-item-content"
                      style="font-size: 21px ;text-transform: none ;color: #3db166 ;"
                    >
                      <p>
                        If you’re an educational professional who are looking to
                        progress into management and consultancy, or an
                        educational planning or development role, this is the
                        best degree for you.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align"
                  >
                    <div
                      class="gdlr-core-divider-line gdlr-core-skin-divider"
                      style="border-color: #3db166 ;border-bottom-width: 3px ;"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="gdlr-core-pbf-sidebar-right gdlr-core-column-extend-right  kingster-sidebar-area gdlr-core-column-20 gdlr-core-pbf-sidebar-padding  gdlr-core-line-height"
              style="padding: 35px 0px 30px 0px;"
            >
              <div class="gdlr-core-sidebar-item gdlr-core-item-pdlr">
                <div id="text-18" class="widget widget_text kingster-widget">
                  <div class="textwidget">
                    <div
                      class="gdlr-core-widget-box-shortcode "
                      style="color: #ffffff ;padding: 30px 45px;background-color: #192f59 ;"
                    >
                      <div
                        class="gdlr-core-widget-box-shortcode-content"
                        data-aos="zoom-in"
                        :data-aos-duration="index + `000`"
                        :data-aos-delay="index + `00`"
                      >
                        <p></p>
                        <h3
                          style="font-size: 20px; color: #fff; margin-bottom: 25px;"
                        >
                          Informasi Kontak
                        </h3>
                        <p>
                          <span
                            style="color: #3db166; font-size: 16px; font-weight: 600;"
                            >{{ meta.name }}</span
                          >
                          <br />
                          <span style="font-size: 15px;"
                            ><br />
                            {{ meta.address }}<br />
                            {{ meta.sub_district }},{{ meta.city }}.
                            {{ meta.province }}</span
                          >
                        </p>
                        <p>
                          <span style="font-size: 15px;"
                            >{{ meta.phone }}<br />
                            {{ meta.email }}<br />
                          </span>
                        </p>
                        <p>
                          <span style="font-size: 16px; color: #3db166;"
                            >Senin – Jumat 8:00 Pagi – 5:00 Sore</span
                          >
                        </p>
                        <span
                          class="gdlr-core-space-shortcode"
                          style="margin-top: 40px ;"
                        ></span>
                        <h3
                          style="font-size: 20px; color: #fff; margin-bottom: 15px;"
                        >
                          Sosial Media
                        </h3>
                        <div
                          class="gdlr-core-social-network-item gdlr-core-item-pdb  gdlr-core-none-align"
                          style="padding-bottom: 0px ;"
                        >
                          <a
                            v-if="contact && contact.facebook"
                            :href="contact.facebook.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="facebook"
                            style="color: #3db166 ;"
                            ><i class="fa fa-facebook"></i></a
                          ><a
                            v-if="contact && contact.linkedin"
                            :href="contact.linkedin.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="linkedin"
                            style="color: #3db166 ;"
                            ><i class="fa fa-linkedin"></i></a
                          ><a
                            v-if="contact && contact.twitter"
                            :href="contact.twitter.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="twitter"
                            style="color: #3db166 ;"
                            ><i class="fa fa-twitter"></i></a
                          ><a
                            v-if="contact && contact.instagram"
                            :href="contact.instagram.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="instagram"
                            style="color: #3db166 ;"
                            ><i class="fa fa-instagram"></i
                          ></a>
                          <a
                            v-if="contact && contact.youtube"
                            :href="contact.youtube.body"
                            target="_blank"
                            class="gdlr-core-social-network-icon"
                            title="youtube"
                            style="color: #3db166 ;"
                            ><i class="fa fa-youtube"></i
                          ></a>
                        </div>
                        <span
                          class="gdlr-core-space-shortcode"
                          style="margin-top: 40px ;"
                        ></span>
                        <!-- <a
                          class="gdlr-core-button gdlr-core-button-shortcode  gdlr-core-button-gradient gdlr-core-button-no-border"
                          href="#"
                          style="padding: 16px 27px 18px;margin-right: 20px;border-radius: 2px;-moz-border-radius: 2px;-webkit-border-radius: 2px;"
                          ><span class="gdlr-core-content"
                            >Student Resources</span
                          ></a
                        > -->
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["meta", "majors", "contact"],
};
</script>
